// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_dLb","cls2":"PaperSelector-cls2_Q_S PaperSelector-cls1_dLb"};